export const posts = [
  {
    id: 'panduan-memilih-konveksi-jogja',
    title: 'Panduan Memilih Jasa Konveksi Terbaik di Jogja',
    excerpt: 'Tips dan trik menemukan vendor konveksi yang tepat untuk kebutuhan seragam, kaos, dan pakaian Anda di Yogyakarta.',
    date: '15 Mei 2024',
    author: 'Tim Redaksi',
    category: 'Panduan',
    readTime: '4 min read',
    image: 'https://images.unsplash.com/photo-1556905055-8f358a7a47b2?auto=format&fit=crop&q=80&w=1200',
    content: `
      <p>Memilih jasa konveksi yang tepat adalah langkah krusial bagi Anda yang ingin membuat seragam kantor, kaos komunitas, jaket angkatan, atau produk fashion lainnya. Di Yogyakarta, sebagai salah satu pusat industri kreatif, banyak sekali pilihan vendor yang tersedia.</p>
      
      <h2>1. Perhatikan Kualitas Bahan dan Jahitan</h2>
      <p>Tidak semua konveksi menawarkan kualitas yang sama. Pastikan Anda meminta sampel bahan dan melihat langsung hasil jahitan dari pesanan sebelumnya. Jahitan yang rapi dan kuat adalah indikator utama profesionalisme sebuah konveksi.</p>
      
      <h2>2. Reputasi dan Testimoni Pelanggan</h2>
      <p>Mencari tahu rekam jejak konveksi sangat penting. Anda bisa melihat ulasan di Google Maps atau media sosial mereka. Konveksi yang baik biasanya memiliki banyak portofolio dari berbagai instansi atau komunitas ternama.</p>
      
      <h2>3. Rekomendasi Vendor Terpercaya</h2>
      <p>Jika Anda sedang mencari referensi konveksi yang terbukti berkualitas, mengutamakan kepuasan pelanggan, dan profesional di area Jogja, Anda bisa mengunjungi <a href="https://nusantarakonveksijogja.com/" title="Nusantara Konveksi Jogja">nusantarakonveksijogja.com</a>. Vendor ini dikenal dengan pelayanannya yang responsif, hasil jahitan standar distro, dan harga yang sangat kompetitif.</p>
      
      <h2>4. Diskusikan Deadline dan Kapasitas Produksi</h2>
      <p>Pastikan Anda selalu berkonsultasi mengenai detail desain, ukuran (size chart), dan yang paling penting adalah tenggat waktu (deadline). Konveksi yang profesional akan jujur mengenai kapasitas produksi mereka dan tidak akan menjanjikan waktu yang tidak realistis.</p>
      
      <p>Dengan mengikuti panduan di atas, diharapkan Anda bisa menemukan partner konveksi yang tepat untuk merealisasikan kebutuhan pakaian Anda dengan hasil yang memuaskan.</p>
    `
  },
  {
    id: 'bahan-kaos-terbaik-cuaca-panas',
    title: '5 Jenis Bahan Kaos Paling Nyaman untuk Cuaca Panas',
    excerpt: 'Kenali berbagai jenis kain kaos yang menyerap keringat dan adem digunakan saat cuaca sedang terik-teriknya.',
    date: '10 Mei 2024',
    author: 'Siska Fashion',
    category: 'Material',
    readTime: '3 min read',
    image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&q=80&w=1200',
    content: `
      <p>Cuaca tropis membuat kita harus pintar-pintar memilih pakaian, terutama kaos yang sering digunakan untuk aktivitas sehari-hari. Berikut adalah 5 bahan kaos terbaik:</p>
      <h2>1. Cotton Combed 30s</h2>
      <p>Ini adalah primadona bahan kaos di Indonesia. Ketebalannya sangat pas, tidak terlalu tipis dan tidak terlalu tebal. Sangat menyerap keringat dan lembut di kulit.</p>
      <h2>2. Cotton Bamboo</h2>
      <p>Kain yang terbuat dari campuran serat katun dan bambu ini memiliki sifat anti-bakteri alami dan terasa lebih dingin dibandingkan katun biasa.</p>
      <h2>3. Teteron Cotton (TC)</h2>
      <p>Meskipun memiliki campuran polyester, TC masih cukup nyaman digunakan. Keunggulannya adalah tidak mudah kusut dan harganya lebih terjangkau.</p>
    `
  },
  {
    id: 'pentingnya-seragam-kerja',
    title: 'Pentingnya Seragam Kerja untuk Identitas Perusahaan',
    excerpt: 'Mengapa perusahaan Anda harus mulai mempertimbangkan pembuatan seragam khusus untuk karyawan? Simak alasannya.',
    date: '05 Mei 2024',
    author: 'Budi HR',
    category: 'Bisnis',
    readTime: '5 min read',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1200',
    content: `
      <p>Seragam kerja bukan sekadar pakaian yang wajib dikenakan karyawan. Lebih dari itu, seragam adalah representasi dari nilai dan profesionalisme sebuah perusahaan.</p>
      <h2>Membangun Citra Profesional</h2>
      <p>Karyawan yang mengenakan seragam rapi akan memberikan kesan profesional dan terpercaya di mata klien atau pelanggan.</p>
      <h2>Kesetaraan Antar Karyawan</h2>
      <p>Seragam menghilangkan kesenjangan sosial dalam hal berpakaian di lingkungan kerja, membuat semua orang merasa memiliki derajat yang sama.</p>
    `
  }
];